import React from 'react';
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,
} from '@mui/material';
import { Code } from 'dashboard/components/common';
import { fmtMoney } from 'utilities/format';

/** Line-item table inside the order detail dialog. Currency comes from the parent order. */
export default function OrderLineItemsTable({ order: o }) {
  return (
    <Box mb='14px'>
      <Typography variant='body2' fontWeight='700' mb='6px'>Line items</Typography>
      <TableContainer
        component={Box}
        sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '10px', overflowX: 'auto' }}
      >
        <Table size='small'>
          <TableHead sx={{ bgcolor: 'action.hover' }}>
            <TableRow>
              <TableCell>Item</TableCell>
              <TableCell>SKU</TableCell>
              <TableCell align='right'>Qty</TableCell>
              <TableCell align='right'>Unit</TableCell>
              <TableCell align='right'>Line</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(o.line_items || []).map((li) => (
              <TableRow key={li._id || li.variant_id}>
                <TableCell>
                  <Typography variant='body2' fontWeight='600'>{li.product_name}</Typography>
                  {li.variant_name && (
                    <Typography variant='caption' color='text.secondary'>
                      {li.variant_name}
                    </Typography>
                  )}
                </TableCell>
                <TableCell><Code>{li.sku || '—'}</Code></TableCell>
                <TableCell align='right'>{li.quantity}</TableCell>
                <TableCell align='right'>{fmtMoney(li.unit_price, o.currency)}</TableCell>
                <TableCell align='right'>{fmtMoney(li.line_total, o.currency)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
